/**
 * Classes Tailwind reutilizáveis com suporte a modo escuro.
 * Preferir tokens semânticos (bg-card, border-border) quando possível.
 */

/** Superfície principal de card / painel */
export const surfaceCard = 'bg-card text-card-foreground border-border';

/** Superfície secundária (listas, blocos internos) */
export const surfaceMuted = 'bg-muted/50 border-border';

/** Painel informativo azul */
export const infoPanel =
  'bg-blue-50 dark:bg-blue-950/40 border border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200';

/** Painel neutro interno */
export const neutralPanel = 'bg-muted/50 border border-border';

/** Stat box — em atraso (azul) */
export const statBoxBlue =
  'text-center p-1.5 rounded-lg border bg-blue-50 dark:bg-blue-950/30 border-blue-100 dark:border-blue-900';

export const statBoxBlueLabel = 'text-sm font-bold text-blue-700 dark:text-blue-300';
export const statBoxBlueCaption = 'text-xs text-blue-600 dark:text-blue-400';

/** Stat box — valor vencido (vermelho) */
export const statBoxRed =
  'text-center p-1.5 rounded-lg border bg-red-50 dark:bg-red-950/30 border-red-100 dark:border-red-900';

export const statBoxRedLabel = 'text-sm font-bold text-red-700 dark:text-red-300';
export const statBoxRedCaption = 'text-xs text-red-600 dark:text-red-400';

/** Stat box — dias em atraso (laranja) */
export const statBoxOrange =
  'flex items-center justify-between p-1.5 rounded-lg border bg-orange-50 dark:bg-orange-950/30 border-orange-100 dark:border-orange-900';

export const statBoxOrangeLabel = 'text-sm font-medium text-orange-800 dark:text-orange-200';
export const statBoxOrangeValue = 'text-sm font-bold text-orange-800 dark:text-orange-200';

/** Total geral no card */
export const statBoxTotal =
  'text-center p-2 rounded-lg border bg-muted/50 border-border';

/** Badge gestor aceito */
export const gestorBadgeAccepted =
  'text-xs bg-green-100 text-green-800 border-green-200 dark:bg-green-500/20 dark:text-green-200 dark:border-green-800';

/** Badge gestor negado */
export const gestorBadgeDenied =
  'text-xs bg-red-100 text-red-800 border-red-200 dark:bg-red-500/20 dark:text-red-200 dark:border-red-800';

/** Avatar circular operador */
export const operatorAvatar =
  'flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center bg-blue-100 dark:bg-blue-900/40';

export const operatorAvatarIcon = 'w-3 h-3 text-blue-600 dark:text-blue-300';

/** Avatar placeholder sem operador */
export const operatorAvatarEmpty =
  'flex-shrink-0 w-4 h-4 rounded-full flex items-center justify-center bg-muted';

/** Separador de seção no card */
export const cardSectionBorder = 'border-b border-border';

/** Tab inativa */
export const tabInactive =
  'bg-muted text-muted-foreground hover:bg-muted/80 dark:hover:bg-slate-700';

/** Item de lista hover */
export const listItemHover = 'hover:bg-muted/80 dark:hover:bg-slate-800';

/** Item de lista selecionado (azul) */
export const listItemSelected = 'bg-blue-50 dark:bg-blue-950/30 border-l-4 border-l-blue-500';

/** Botão ghost azul pequeno */
export const btnGhostBlue =
  'text-blue-700 dark:text-blue-300 bg-blue-50 dark:bg-blue-950/40 border-blue-200 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-900/50';

/** Coluna kanban */
export const kanbanColumnChrome = 'bg-muted/80 dark:bg-slate-800/80';
